import { createFileRoute, Navigate } from '@tanstack/react-router'
import { useAuth_M1_2 } from '@/contexts/AuthProvider'

function IndexPage_M10_20() {
  const { isSignedIn } = useAuth_M1_2()

  if (isSignedIn) {
    return <Navigate to="/dashboard" />
  }

  return <Navigate to="/login" />
}

export const Route = createFileRoute('/')({
  component: IndexPage_M10_20,
})
